import { render, staticRenderFns } from "./rightPageYJ.vue?vue&type=template&id=0e17e46d&scoped=true&"
import script from "./rightPageYJ.vue?vue&type=script&lang=js&"
export * from "./rightPageYJ.vue?vue&type=script&lang=js&"
import style0 from "./rightPageYJ.vue?vue&type=style&index=0&id=0e17e46d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e17e46d",
  null
  
)

export default component.exports